import type { QuickStepsStore } from './schema/QuickStepsConfig';
import { createStore } from 'satcheljs';
import { ObservableMap } from 'mobx';

const store = createStore<QuickStepsStore>('quickStepsStore', {
    quickStepsStoreMap: new ObservableMap(),
})();
const getStore = () => store;
export default getStore;
